import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/navbar/Header';
import Footer from '../../components/footer/footer';
import { useTranslation } from 'react-i18next';

const TermsPage: React.FC = () => {
  const { t } = useTranslation();
  // Effet pour défiler en douceur vers le haut de la page au chargement
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, []);

  return (
    <>
    <div className="container mx-auto px-4 py-12 md:py-20 max-w-4xl">
      <Header />
      <h1 className="text-3xl md:text-4xl font-bold mt-8 mb-8 text-gray-800 text-primary">
        {t("terms.title")}
      </h1>

      <div className="prose prose-lg max-w-none text-gray-700">
        {/* Mentions légales */}
        <section className="mb-10">
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            {t("terms.sections.legal.title")}
          </h2>

          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">
              {t("terms.sections.legal.editor.title")}
            </h3>
            <p>{t("terms.sections.legal.editor.content.0")}</p>
            <ul className="mt-2">
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <li key={i}>{t(`terms.sections.legal.editor.content.${i}`)}</li>
              ))}
            </ul>
          </div>

          <div className="mb-6">
            <h3 className="text-lg font-semibold mb-2">
              {t("terms.sections.legal.hosting.title")}
            </h3>
            <p>{t("terms.sections.legal.hosting.content.0")}</p>
            <ul className="mt-2">
              {[1, 2, 3, 4, 5].map((i) => (
                <li key={i}>{t(`terms.sections.legal.hosting.content.${i}`)}</li>
              ))}
            </ul>
          </div>
        </section>

        {/* Sections 1 à 13 */}
        {Array.from({ length: 13 }, (_, i) => {
          const sectionKeys = [
            "intro",
            "serviceDescription",
            "usageTerms",
            "personalData",
            "subscriptions",
            "payments",
            "accountManagement",
            "intellectualProperty",
            "responsibility",
            "liability",
            "reporting",
            "changes",
            "contact",
          ];

          const key = sectionKeys[i];
          const section = t(`terms.sections.${key}`, { returnObjects: true }) as {
            title: string;
            content: string | string[];
          };

          return (
            <section className="mb-10" key={key}>
              <h2 className="text-2xl font-semibold mb-4 text-gray-800">
                {section.title}
              </h2>

              {Array.isArray(section.content) ? (
                section.content.map((p, idx) => (
                  <p key={idx} className="mb-4">
                    {key === "personalData" && idx === 0 ? (
                      <>
                        {p}
                      </>
                    ) : (
                      p
                    )}
                  </p>
                ))
              ) : (
                <p>{section.content}</p>
              )}
            </section>
          );
        })}

        {/* Dernière mise à jour */}
        <div className="mt-12 text-sm text-gray-500">
          <p>{t("terms.sections.updatedAt")}</p>
        </div>
      </div>
    </div>
    <Footer />
    </>
  );
};

export default TermsPage;
